//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Link",0,"SelectNXObjectList",0],[0,"VectorScale",1,0]],[[["count"],"GetRecordedSteps",{R_:{steps:""}},0,0],[["steps"],"SetRecordedSteps",{},1,0],[["graph_count"],"CreateGraphObjects",{R_:{graph_objects:"Motion.Graph[]"}},0,0],[["afu"],"StoreGraphInAfu",{},1,0]],[]];
SPLM.Motion.LoadTransferBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LoadTransferBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;